import { Component, OnInit } from '@angular/core';
import { DispatchService } from '@app/shared/services/dispatch.service';
import { ChangeDetectorRef } from '@angular/core';
import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
import { OrderDataService } from '@app/shared/services/order-data.service';
import { forkJoin, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import * as XLSX from 'xlsx';  // Import XLSX for Excel export
import jsPDF from 'jspdf';

// interface Dispatch {
//   _id: string;
//   totalDispatched?: number;
//   kgsBal?: number;
//   status?: string;
//   created: string;  // Ensure `created` field is a string for date comparisons
// }

interface Dispatch {
  LamType: string;
  _id: string;
  totalDispatched?: number;
  kgsBal?: number;
  status?: string;
  created: string;  // Ensure `created` field is a string for date comparisons
  date1:string;
  refNo?: string;     // Add the missing properties
  poNo?: string;
  jobName?: string;
  clientName?: string;
  ticketno?: string;
  // orderType?:string;
}

@Component({
  selector: 'app-parents-order',
  templateUrl: './parents-order.component.html',
  styleUrls: ['./parents-order.component.css']
})
export class ParentsOrderComponent implements OnInit {

  repeatOrders: any[] = [];
  unsavedOrders: any[] = [];
  dispatches: Dispatch[] = [];  // Array to hold the merged dispatch data
  filteredDispatches: Dispatch[] = [];  // Filtered dispatches based on date range
  fromDate: string = '';
  toDate: string = '';
  currentSortColumn: string = '';
  currentSortDirection: 'asc' | 'desc' = 'asc';

 // Search Filters
 refNoFilter: string = '';
 poNoFilter: string = '';
 jobNameFilter: string = '';
 clientNameFilter: string = '';
 ticketNoFilter: string = '';
 statusFilter: string = '';  // Filter for status: 'ticketGenerated' or 'Repeated Order'
 clientList: any[] = [];
 page: number = 1;
 limit: number = 10;
 pageTotalItem: number = 0;
 private loadOrders$ = new Subject<void>();
 filteredDate: any ={
  fromDate: '',
  toDate: '',
  status: '',
  refNo: '',
  poNo: '',
  jobName: '',
  clientName: '',
  ticketno: ''
 } 
  constructor(
    private dispatchService: DispatchService,
    private repeatOrderService: RepeatOrderService,
    private orderDataService: OrderDataService,
    private cdr: ChangeDetectorRef
  ) { }


ngOnInit(): void {
  this.loadOrders$
    .pipe(
      // debounceTime(300),
      // distinctUntilChanged(),
      switchMap(() =>
        this.orderDataService.getAllOrders(this.page, this.limit, this.filteredDate)
      )
    ).subscribe((res: any) => {
      this.dispatches = res.data;
      this.pageTotalItem = res.total;
       if (res.data && res.data.length > 0) {
          this.dispatches = [...res.data];
          this.dispatches.sort((a, b) => {
            return Number(b.ticketno) - Number(a.ticketno);
          });
          this.filteredDispatches = [...this.dispatches];
        } else {
          // Clear table when no data found
          this.dispatches = [];
          this.filteredDispatches = [];
          this.pageTotalItem = 0;
        }        
        this.cdr.detectChanges();
      // }
    });

  this.loadOrders$.next();

  this.getAllOrders();
  this.getClientNames();
  // Fetch data from all services and merge the results
  // forkJoin({
  //   repeatOrders: this.repeatOrderService.getAllRepeatOrdersDisp(),
  //   unsavedOrders: this.orderDataService.getAllunsavedOrdersDisp()
  // }).subscribe({
  //   next: (data) => {
  //     console.log('Repeat Orders:', data.repeatOrders);
  //     this.dispatches = [
  //       ...(Array.isArray(data.repeatOrders) ? data.repeatOrders : [data.repeatOrders]),
  //       ...(Array.isArray(data.unsavedOrders) ? data.unsavedOrders : [data.unsavedOrders])
  //     ];
  //     console.log('Merged Dispatches:', this.dispatches);  // Log the merged data for debugging
  //     // Build unique client list for dropdown
  //     this.clientList = Array.from(
  //       new Set(this.dispatches.map(dispatch => dispatch.clientName).filter(name => !!name))
  //     ).sort();
      
  //     this.dispatches.sort((a, b) => {
  //       return Number(b.ticketno) - Number(a.ticketno);
  //     });
      
  //     this.filteredDispatches = [...this.dispatches];  // Initially show all data
    
  //     this.applyFilters();  // Apply any filter after data is loaded
  //     this.cdr.detectChanges();
  //   },
  //   error: (err) => {
  //     console.error('Error fetching data', err);
  //   }
  // });
}

getAllOrders(){
    this.loadOrders$.next();
}
getClientNames(){
  this.orderDataService.getClientNames().subscribe((res:any)=>{
      this.clientList = Array.from(new Set(res.map((d: any) => d.clientName).filter(Boolean))).sort();
  },(err:any)=>{
      console.error('Error fetching data', err);
  })
}
loadDispatchDetails() {
  const dispatchDetailsCalls = this.dispatches.map((dispatch) =>
    this.dispatchService.getDispatchBydispatchId(dispatch._id).pipe(
      catchError((error) => {
        console.error('Error fetching dispatch for ID:', dispatch._id, error);
        return of(null);  // Handle the error gracefully but log it
      })
    )
  );
  return forkJoin(dispatchDetailsCalls);
}

// Apply the combined filters (date, status, and search fields)
applyFilters() {
  // Apply Date Filter
  if (this.fromDate && this.toDate) {
    this.filteredDate['fromDate'] = this.fromDate;
    this.filteredDate['toDate'] = this.toDate;
  }

  this.filteredDate['status'] = this.statusFilter;  
  this.filteredDate['refNo'] = this.refNoFilter;
  this.filteredDate['poNo'] = this.poNoFilter;
  this.filteredDate['jobName'] = this.jobNameFilter;
  this.filteredDate['clientName'] = this.clientNameFilter;
  this.filteredDate['ticketno'] = this.ticketNoFilter;
  this.page=1;
  this.getAllOrders();
}

  sortTable(column: string) {
    const direction = this.currentSortColumn === column && this.currentSortDirection === 'asc' ? 'desc' : 'asc';
    this.currentSortColumn = column;
    this.currentSortDirection = direction;

    this.filteredDispatches.sort((a, b) => {
      const aVal = a[column];
      const bVal = b[column];
      if (aVal < bVal) return direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  }

  exportToExcel() {
    this.orderDataService.getExportOrders(this.filteredDate).subscribe((res:any)=>{
      
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(res);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Dispatches');
      XLSX.writeFile(wb, 'dispatches_report.xlsx');
    },(err:any)=>{
      console.error('Error fetching data', err);
    })
  }

  


  previewOrder(orders: any) {
      // Log the order object to the console to inspect its data
    console.log('Order Data:', orders);
    this.dispatchService.getDispatchByPredispatchId(orders._id).subscribe((order:any)=>{
      let dispStatus =order.status ; 
      // Check the order status
      let orderStatus = order.orderType ; // Default to 'Unknown Status' if status is missing
      if (orderStatus === 'Repeated Order') {
        orderStatus = 'Repeated order';
      } else if (orderStatus === 'ticketGenerated') {
        orderStatus = 'New Order';
      } 
    console.log('Order orderStatus:',orderStatus);

      // else if (orderStatus === 'Open') {
      //   orderStatus = 'Open';
      // } else if (orderStatus === 'Closed') {
      //   orderStatus = 'Closed';
      // }

      console.log('Folder No (jssfolderno):', order.jssfolderno);
        const doc = new jsPDF();

        const pageWidth = doc.internal.pageSize.width;
        const topMargin = 2;
        const sideMargin = 10;
        doc.setFont('helvetica');
        const adjustedTop = topMargin + 8;
        const adjustedLeft = sideMargin + 10;
        doc.setFont('helvetica', 'bold');
        const ticketText = 'LEXIPACK GHANA LIMITED';
        const companyName = order.clientName || '';
        const companyJob = `${order.jobName || ''} (${order.jobType || ''})`;
        const textWidth = doc.getTextWidth(ticketText);
        const textX = (pageWidth - textWidth) / 2;
        doc.setFontSize(13);
        doc.text(ticketText, textX, adjustedTop + 2);
        doc.text(companyName, adjustedLeft, adjustedTop + 10);
        doc.text(companyJob, adjustedLeft, adjustedTop + 16);
        doc.line(sideMargin, adjustedTop + 18, pageWidth - sideMargin, adjustedTop + 18);
        doc.setFontSize(11);
        doc.setFont('helvetica', 'normal'); // Set font back to normal

        // Render client and job details
        const PoNo = `Po No: ${order.poNo}`;
        doc.text(PoNo, adjustedLeft - 8, adjustedTop + 23);
      const originalDate = new Date(order.created);
      const formattedDate = originalDate.toISOString().split('T')[0];

      const formattedDateString = `Date: ${formattedDate}`;
      doc.text(formattedDateString, adjustedLeft + 60, adjustedTop + 23);
        // Get current time
        const currentDate = new Date();
        const currentTime = currentDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        const time = `Time: ${currentTime}`;  // Update the time field with current time
        doc.text(time, adjustedLeft + 95, adjustedTop + 23);

        // Set font style to bold
        doc.setFontSize(13); // Change the number to your desired font size
        doc.setFont('helvetica', 'bold');
        const Challan_No = `Ticket No: ${order.ticketno}`;
        doc.text(Challan_No, adjustedLeft + 140, adjustedTop + 10);
        // Assuming you have initialized doc, adjustedLeft, adjustedTop, and order.refNo appropriately
        doc.setFontSize(11); // Set to the default or desired font size for Ref No
        // Define the clientDetails string
        const clientDetails = `Ref No: ${order.refNo}`;

        // Set font style to bold
        doc.setFont('helvetica', 'bold');

        // Render the text with bold font
        doc.text(clientDetails, adjustedLeft - 8, adjustedTop + 32);



        const Serial = `FolderNo: ${order.jssfolderno}`;
        doc.text(Serial, adjustedLeft + 60, adjustedTop + 32);
        // Reset font style to normal (if needed for subsequent text)
        doc.setFont('helvetica', 'normal');
        const Barcode = `Barcode: ${order.barcode}`;
        doc.text(Barcode, adjustedLeft + 140, adjustedTop + 32);
        // const gstDetails = `JobName: ${order.jobName}`;
        // doc.text(gstDetails, adjustedLeft - 8, adjustedTop + 36);
        const Total_CMT = `JobType: ${order.jobType}`;
        doc.text(Total_CMT, adjustedLeft - 8, adjustedTop + 40);
    
        // const ddDate = new Date(order.date1 || order.ddDate);
        // const formattedddDate = ddDate.toISOString().split('T')[0];

        // const formattedDDDateString = `Delivery Date: ${formattedddDate}`;
        // doc.text(formattedDDDateString, adjustedLeft + 140, adjustedTop + 37);
// 

        // Safely get the date string
const rawDate = order.date1 || order.ddDate;

let formattedddDate = 'N/A'; // Default fallback

if (rawDate) {
  const ddDate = new Date(rawDate);
  if (!isNaN(ddDate.getTime())) {
    // Date is valid
    formattedddDate = ddDate.toISOString().split('T')[0];
  } else {
    console.warn('⚠️ Invalid date format in order:', rawDate);
  }
} else {
  console.warn('⚠️ No ddDate or date1 found in order object.');
}

// Draw text on PDF
const formattedDDDateString = `Delivery Date: ${formattedddDate}`;
doc.text(formattedDDDateString, adjustedLeft + 140, adjustedTop + 37);
// 
// 
        // const deliveyDate = `Delivey Date: ${order.date1}`;
        // doc.text(deliveyDate, adjustedLeft + 140, adjustedTop + 40); dispStatus
        const dispStatus1 = `Dispatch Status:${dispStatus}`;
        doc.text(dispStatus1, adjustedLeft + 140, adjustedTop + 43);
        const status = `Order Type:${orderStatus}`;
        doc.text(status, adjustedLeft + 140, adjustedTop + 49);
        // const status = `Status: ${order.newOrder}`;
        // doc.text(status, adjustedLeft + 140, adjustedTop + 45);
        // const driverDetails = `Pouch / Pcs : ${order.pouch}`;
        // doc.text(driverDetails, adjustedLeft + 60, adjustedTop + 44);


        const gradeQtyDetails = `Quantity:-`;
        doc.text(gradeQtyDetails, adjustedLeft - 8, adjustedTop + 50);
        // const Qty = `Kgs: ${order.orderKgs}`;
        const Qty = `Kgs: ${parseFloat(order.orderKgs).toFixed(2)}`;
        doc.text(Qty, adjustedLeft + 20, adjustedTop + 50);
        // const TM_No = `PCs: ${order.pouch || order.orderPcs} `;
        const pcsValue = order.pouch || order.orderPcs;
const TM_No = `PCs: ${parseFloat(pcsValue).toFixed(2)}`;
        doc.text(TM_No, adjustedLeft + 20, adjustedTop + 55);

        
        // const Time_Out = `Cylinder Location: ${order.location || ''}`;
        // doc.text(Time_Out, adjustedLeft + 96, adjustedTop + 49);
        // const Time_In = `Remarks: ${order.remark}`;
        // doc.text(Time_In, adjustedLeft + 90, adjustedTop + 55);

        const remarksText = `Remarks: ${order.repeatedRemarks || order.remark}`;
        const maxLineWidth = pageWidth - adjustedLeft - 90; // Define max width for the text
        
        // Split the remark text into lines that fit within the allowed width
        const remarksLines = doc.splitTextToSize(remarksText, maxLineWidth);
        
        // Start drawing the text at the adjusted position
        let yPosition = adjustedTop + 53;
        
        // Draw each line of the remark text, adjusting the Y position for each new line
        remarksLines.forEach(line => {
          doc.text(line, adjustedLeft + 91, yPosition);
          yPosition += 6; // Adjust line spacing as needed
        });
    // Arrays for material allocation details
    const processes = [
      'Process1', 'Process2', 'Process3', 'Process4', 'Process5', 'Process6'
    ];

    // Material Allocation section
    doc.line(sideMargin, adjustedTop + 59, pageWidth - sideMargin, adjustedTop + 59);
    doc.text(`RAW MATERIAL ALLOCATION`, adjustedLeft - 8, adjustedTop + 65);
    doc.text(`Processes`, adjustedLeft - 5, adjustedTop + 70);
    doc.text(`Material`, adjustedLeft + 50, adjustedTop + 70);
    doc.text(`Size (mm)`, adjustedLeft + 105, adjustedTop + 70);
    doc.text(`Thickness (µ)`, adjustedLeft + 129, adjustedTop + 70);
    doc.text(`Mat Req(kgs)`, adjustedLeft + 155, adjustedTop + 70);

    // Case when orderStatus is not 'ticketGenerated'
    if (orderStatus !== 'ticketGenerated') {
      // Check if combinedMaterials is defined and is an array
      if (Array.isArray(order.combinedMaterials) && order.combinedMaterials.length > 0) {
        order.combinedMaterials.forEach((material, index) => {
          if (material.process && material.material) {
            // Get process number from the processes array
            const processLabel = processes[index] || `Process ${index + 1}`; // Fallback if there are more materials than processes
            const combinedProcess = `${processLabel}: ${material.process}`; // Combine both labels

            doc.text(combinedProcess, adjustedLeft - 7, adjustedTop + 80 + index * 6);
            doc.text(String(material.material), adjustedLeft + 50, adjustedTop + 80 + index * 6);
            doc.text(String(material.width !== undefined ? material.width : 0), adjustedLeft + 105, adjustedTop + 80 + index * 6);
            doc.text(String(material.thickness !== undefined ? material.thickness : 0), adjustedLeft + 129, adjustedTop + 80 + index * 6);
            doc.text(String(material.matRequired !== undefined ? material.matRequired : 0), adjustedLeft + 155, adjustedTop + 80 + index * 6);
          }
        });
      } else {
        console.error('combinedMaterials is not an array or is empty');
      }

            // Access cylinder properties
            const cylinder = order.cylinders || {}; // Safely access cylinders
            const cylinderSupplier = cylinder.supplier || '';
            const cylinderLength = cylinder.length || '';
            const cylinderLocation = cylinder.location || '';
            const cylinderCircumference = cylinder.circumference || '';

            const Time_Out = `Cylinder Location: ${cylinderLocation}`;
            doc.text(Time_Out, adjustedLeft + 130, adjustedTop + 146);
            doc.text(`Cylinder Supplier: ${cylinderSupplier}`, adjustedLeft - 7, adjustedTop + 128);
            doc.text(`Cylinder ID: ${cylinder.id || ''}`, adjustedLeft + 60, adjustedTop + 128);
            const Face_Length = `Face Length (mm): ${cylinderLength}`;
            doc.text(Face_Length, adjustedLeft + 115, adjustedTop + 128);
            // doc.text(`Print type: ${order.printType || ''}`, adjustedLeft - 7, adjustedTop + 136);
            // doc.text(`Print Direction: ${order.printDirection || ''}`, adjustedLeft + 60, adjustedTop + 136);
            const Circum = `Cylinder Circumference(mm): ${cylinderCircumference}`;
            doc.text(Circum, adjustedLeft +56, adjustedTop + 146);
            
    }
    // // Case when orderStatus is 'ticketGenerated'

      const materials = [
        order.material1, order.material2, order.material3, order.material4, order.material5, order.material6
      ];

      const matSizes = [
        order.matSize1, order.matSize2, order.matSize3, order.matSize4, order.matSize5, order.matSize6
      ];

      const thickness = [
        order.thickness1, order.thickness2, order.thickness3, order.thickness4, order.thickness5, order.thickness6
      ];

      const matReqs = [
        order.matReq1, order.matReq2, order.matReq3, order.matReq4, order.matReq5, order.matReq6
      ];

      // Loop through and render each material allocation line
      for (let i = 0; i < processes.length; i++) {
        // Check if the process exists and is not NaN or '0'
        if (order[processes[i]] !== undefined && order[processes[i]] !== 'NaN' && order[processes[i]] !== '0') {
          const processLine = `${processes[i]}: ${order[processes[i]]}`;
          const materialLine = materials[i] !== 'NaN' ? materials[i] : '';
          const matSizeLine = matSizes[i] !== 'NaN' ? matSizes[i] : '';
          const thicknessLine = thickness[i] !== 'NaN' ? thickness[i] : '';
          const matReqLine = matReqs[i] !== 'NaN' ? matReqs[i] : '';

          doc.text(processLine, adjustedLeft - 7, adjustedTop + 80 + i * 6);
          doc.text(materialLine, adjustedLeft + 50, adjustedTop + 80 + i * 6);
          doc.text(matSizeLine, adjustedLeft + 105, adjustedTop + 80 + i * 6);
          doc.text(thicknessLine, adjustedLeft + 129, adjustedTop + 80 + i * 6);
          doc.text(matReqLine, adjustedLeft + 155, adjustedTop + 80 + i * 6);
        }
      }





        // Additional sections (Printing, Lamination, Slitting, Packing, Gluing and Sleeves, Bottom Design)
        // These sections should be filled according to your specific needs

        // Example section (Printing)
        doc.line(sideMargin, adjustedTop + 112, pageWidth - sideMargin, adjustedTop + 112);
        doc.text(`PRINTING`, adjustedLeft - 8, adjustedTop + 118);
        doc.text(`Cylinder Supplier: ${order.supplier || ''}`, adjustedLeft - 7, adjustedTop + 128);
        doc.text(`Cylinder ID: ${order.id || ''}`, adjustedLeft + 60, adjustedTop + 128);
        const Face_Length = `Face Length (mm): ${order.length || ''}`;
        doc.text(Face_Length, adjustedLeft + 115, adjustedTop + 128);
        doc.text(`Print type: ${order.printType || ''}`, adjustedLeft - 7, adjustedTop + 136);
        doc.text(`Print Direction: ${order.printDirection || ''}`, adjustedLeft + 60, adjustedTop + 136);
        const Circum = `Cylinder Circumference(mm): ${order.circumference || ''}`;
        doc.text(Circum, adjustedLeft + 56, adjustedTop + 146);

        // const CONS = `CONS:-`;
        // doc.text(CONS, adjustedLeft - 7, adjustedTop + 146);
        const Ink_GSM = `Ink GSM: ${order.std}`;
        doc.text(Ink_GSM, adjustedLeft - 7, adjustedTop + 146);
        // const Liquid_Inks = `Liquid Inks: ${order.liquid}`;
        // doc.text(Liquid_Inks, adjustedLeft + 60, adjustedTop + 146);
        const InkType = `InkType: ${order.inkType}`;
        doc.text(InkType, adjustedLeft + 115, adjustedTop + 156);
        // const No_of_Colors = `No of Colors: ${order.color}`;

        const No_of_Colors = `No of Colors: ${order.colorNumber}`;
        doc.text(No_of_Colors, adjustedLeft - 7, adjustedTop + 156);
        // const ActualPrint ='Actual printing material size:-';
        // doc.text(ActualPrint, adjustedLeft-7 ,adjustedTop + 165);
        const Color_Names = `Color Names:- ${order.colorNames}`;
        doc.text(Color_Names, adjustedLeft - 7, adjustedTop + 165);


        // Example section (Lamination)
        doc.line(sideMargin, adjustedTop + 170, pageWidth - sideMargin, adjustedTop + 170);
        doc.text(`LAMINATION`, adjustedLeft - 8, adjustedTop + 178);
        doc.text(`Lamination Type: ${order.
          LamType || ''}`, adjustedLeft - 8, adjustedTop + 185);
        doc.text(`Adhesive: ${order.nco || ''} x ${order.oh || ''}`, adjustedLeft + 60, adjustedTop + 185);
        doc.text(`Total GSM: ${order.totalGsm || ''}`, adjustedLeft + 140, adjustedTop + 185);


        // Example section (Slitting)
        doc.line(sideMargin, adjustedTop + 190, pageWidth - sideMargin, adjustedTop + 190);
        doc.text(`SLITTING`, adjustedLeft - 8, adjustedTop + 196);
        doc.text(`Core Type: ${order.coreType || ''}`, adjustedLeft - 8, adjustedTop + 203);
        doc.text(`Coil Width(Ups): ${order.coilWidth || ''}`, adjustedLeft - 8, adjustedTop + 210);
        doc.text(`Coil OD(mm): ${order.coilod || ''}`, adjustedLeft + 60, adjustedTop + 210);
        doc.text(`Final Direction: ${order.fdOption || ''}`, adjustedLeft + 115, adjustedTop + 210);
        doc.text(`Repeat Length(Ups): ${order.repeatLength || ''}`, adjustedLeft - 8, adjustedTop + 218);
        doc.text(`No. of Pcs/Kg: ${order.pouch || ''}`, adjustedLeft + 115, adjustedTop + 218);

        // Example section (Packing)
        doc.line(sideMargin, adjustedTop + 222, pageWidth - sideMargin, adjustedTop + 222);
        doc.text(`PACKING`, adjustedLeft - 8, adjustedTop + 228);
        doc.text(`Packing Type: ${order.packageType || ''}`, adjustedLeft - 8, adjustedTop + 235);

        // Example section (Gluing and Sleeves)
        doc.line(sideMargin, adjustedTop + 240, pageWidth - sideMargin, adjustedTop + 240);
        doc.text(`GLUING AND SLEEVES`, adjustedLeft - 8, adjustedTop + 244);
        doc.text(`Gluing: ${order.gluing || ''}`, adjustedLeft - 8, adjustedTop + 250);
        doc.text(`Roll Width: ${order.rollsWidth || ''}`, adjustedLeft + 60, adjustedTop + 250);
        doc.text(`Cutting Size: ${order.cutting || ''}`, adjustedLeft + 115, adjustedTop + 250);
        doc.text(`Prepared By: ${order.prepared || ''}`, adjustedLeft + 10, adjustedTop + 260);
        // doc.text(`Approved by: ${order.approved || ''}`, adjustedLeft + 115, adjustedTop + 260);
        doc.text(`Approved by Sales: ${order.approved || ''}`, adjustedLeft + 115, adjustedTop + 260);
        doc.text(`Approved by QC: ${  ''}`, adjustedLeft + 10, adjustedTop + 270);
        doc.text(`Approved by Operations: ${ ''}`, adjustedLeft + 115, adjustedTop + 270);
        // Example bottom design section
        doc.setFont('helvetica', 'bold');
        doc.text(`---- Job Ticket Report ----`, adjustedLeft + 60, adjustedTop + 280);

        // Save the PDF
        const pdfOutput = doc.output('bloburl');

        // Open the PDF in a new tab for preview
        window.open(pdfOutput);
    },(err:any)=>{
      console.log(err);
    })
   
  }


  
  getNumber(value: any): number {
    if (!value) return 0;
    const num = parseFloat(value.toString().replace(/[^\d.-]/g, ''));
    return isNaN(num) ? 0 : num;
  }





  // pagination
  // Pagination settings
currentPage: number = 1;
itemsPerPage: number = 10; // You can adjust this
_totalItems: number = 0;

get paginatedDispatches(): Dispatch[] {
  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  const endIndex = startIndex + this.itemsPerPage;
  return this.filteredDispatches.slice(startIndex, endIndex);
}

get totalItems(): number {
  return this.filteredDispatches.length;
}

ceil(value: number): number {
  return Math.ceil(value);
}

calculateRangeStart(): number {
  // return (this.currentPage - 1) * this.itemsPerPage + 1;
  return (this.page - 1) * this.limit + 1;
}

calculateRangeEnd(): number {
  // return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
  return Math.min(this.page * this.limit, this.pageTotalItem);
}

onPageChange(page: number): void {
  // const totalPages = this.ceil(this.totalItems / this.itemsPerPage);
  // if (page >= 1 && page <= totalPages) {
  //   this.currentPage = page;
  // }
  this.page = page;
  this.getAllOrders();
}
// 
  
}


//   ngOnInit(): void {
//     // Fetch data from all services and merge the results
//     forkJoin({
//       repeatOrders: this.repeatOrderService.getAllRepeatOrder(),
//       unsavedOrders: this.orderDataService.getAllUnsavedOrders()
//     }).pipe(
//       switchMap((data) => {
//         // Merge both repeat orders and unsaved orders into a single array
//         this.dispatches = [
//           ...(Array.isArray(data.repeatOrders) ? data.repeatOrders : [data.repeatOrders]),
//           ...(Array.isArray(data.unsavedOrders) ? data.unsavedOrders : [data.unsavedOrders])
//         ];

//         this.filteredDispatches = [...this.dispatches];  // Initially show all data
//         // Trigger change detection if necessary
//         this.cdr.detectChanges();

//         return this.loadDispatchDetails();
//       })
//     ).subscribe({
//       next: (dispatchDetails) => {
//         dispatchDetails.forEach((statusData, index) => {
//           if (statusData) {
//             this.dispatches[index].totalDispatched = statusData.dispatched;
//             this.dispatches[index].kgsBal = statusData.kgsBal;
//             this.dispatches[index].status = statusData.status;
//           }
//         });

//         this.applyDateFilter();  // Apply any date filter after data is loaded
//         this.cdr.detectChanges();
//       },
//       error: (err) => {
//         console.error('Error fetching data', err);
//       }
//     });
//   }

  
  


//   loadDispatchDetails() {
//     const dispatchDetailsCalls = this.dispatches.map((dispatch) =>
//       this.dispatchService.getDispatchBydispatchId(dispatch._id).pipe(
//         catchError((error) => {
//           console.error('Error fetching dispatch for ID:', dispatch._id, error);
//           return of(null);  // Handle the error gracefully but log it
//         })
//       )
//     );
//     return forkJoin(dispatchDetailsCalls);
//   }

//   applyDateFilter() {
//     if (!this.fromDate && !this.toDate) {
//       this.filteredDispatches = [...this.dispatches];  // Show all data if no filter is applied
//       return;
//     }

//     const from = this.fromDate ? new Date(this.fromDate) : null;
//     const to = this.toDate ? new Date(this.toDate) : null;

//     this.filteredDispatches = this.dispatches.filter(dispatch => {
//       const dispatchDate = new Date(dispatch.created);

//       // Check if the dispatch date is within the range
//       const isAfterFromDate = from ? dispatchDate >= from : true;
//       const isBeforeToDate = to ? dispatchDate <= to : true;

//       return isAfterFromDate && isBeforeToDate;
//     });
// }
